import axios from 'axios';
import config from '../../../config';
import Cookies from 'js-cookie';

const baseUrl = config.baseUrl; // URL base de tu API
const bodegasEndpoint = '/api/financiero/bodegas'; // Endpoint para el CRUD de bodegas

// Crear una instancia de Axios con la configuración base
const api = axios.create({
    baseURL: baseUrl,
});

// Interceptor de solicitud para añadir el token de autorización
api.interceptors.request.use(
    (config) => {
        const token = Cookies.get('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

/**
 * Función para listar todas las bodegas
 * @returns {Promise<Object>} Respuesta con status y datos o mensaje de error
 */
export const getBodegas = async () => {
    try {
        const response = await api.get(bodegasEndpoint);
        return response.data;
    } catch (error) {
        console.error('Error al obtener las bodegas:', error.message || error);
        return {
            status: error.response ? error.response.status : 500,
            message: error.message || 'Error al obtener las bodegas',
        };
    }
};


export const getResponsables = async () => {
    try {
        const response = await api.get(`${bodegasEndpoint}/responsables`);

        return response.data;
    } catch (error) {
        console.error('Error al obtener los responsables:', error.message || error);
        return {
            status: error.response ? error.response.status : 500,
            message: error.message || 'Error al obtener los responsables',
        };
    }
};
/**
 * Función para crear una nueva bodega
 * @param {Object} bodegaData Datos de la nueva bodega
 * @returns {Promise<Object>} Respuesta con status y datos o mensaje de error
 */
export const createBodega = async (bodegaData) => {
    try {
        const response = await api.post(bodegasEndpoint, bodegaData);
        return response.data;
    } catch (error) {
        console.error('Error al crear la bodega:', error.message || error);
        return {
            status: error.response ? error.response.status : 500,
            message: error.message || 'Error al crear la bodega',
        };
    }
};

/**
 * Función para actualizar una bodega existente
 * @param {number} id ID de la bodega a actualizar
 * @param {Object} bodegaData Datos actualizados de la bodega
 * @returns {Promise<Object>} Respuesta con status y datos o mensaje de error
 */
export const updateBodega = async (id, bodegaData) => {
    try {
        const response = await api.put(`${bodegasEndpoint}/${id}`, bodegaData);

        return {
            status: response.status,           // debe ser 200
            message: response.data.message,    // “Bodega actualizada correctamente”
        };
    } catch (error) {
        const status = error.response?.status || 500;
        const message = error.response?.data?.message || 'Error actualizando bodega';
        return { status, message };
    }
};

/**
 * Función para eliminar una bodega
 * @param {number} id ID de la bodega a eliminar
 * @returns {Promise<Object>} Respuesta con status y datos o mensaje de error
 */
export const deleteBodega = async (id) => {
    try {
        const response = await api.delete(`${bodegasEndpoint}/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error al eliminar la bodega:', error.message || error);
        return {
            status: error.response ? error.response.status : 500,
            message: error.message || 'Error al eliminar la bodega',
        };
    }
};
